export default class CalculationResult {
  id: string;

  summary: string;

  result: number;

  observation: string;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.summary = obj.summary || '';
    this.result = obj.result === 0 ? 0 : obj.result || '';
    this.observation = obj.observation || '';
  }

  public static of(obj: any): CalculationResult {
    return new CalculationResult(obj || {})
  }

  public static ofList(obj: any[]): CalculationResult[] {
    return obj.map(this.of)
  }

  get validResult(): boolean {
    if (this.result === 0) {
      return true;
    }
    return Boolean(this.result);
  }
}
